import React from "react";
import { useLanguage } from "../../Contexts/LanguageContext";

const HeroSection = () => {
    const { language } = useLanguage();

    return (
        <div className="min-h-screen bg-gradient-to-b from-blue-900 via-purple-800 to-purple-900 text-white">
            {/* Hero Section */}
            <header
                className="relative w-full h-screen bg-cover bg-center"
                style={{
                    backgroundImage: `url('/images/digital1.jpg')`,
                }}
            >
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-purple-900 via-transparent to-blue-900 opacity-80"></div>

                {/* Hero Content */}
                <div className="absolute bottom-16 left-8 max-w-lg">
                    <h1
                        className="text-5xl font-bold text-white"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                        Hodgies Art
                    </h1>
                    <p
                        className="mt-4 text-lg"
                        style={{ fontFamily: "'Lora', serif" }}
                    >
                        {language === "English"
                            ? "Explore the vivid and emotional world of my artistic creations. Each piece tells a unique story."
                            : "Explora el mundo vívido y emocional de mis creaciones artísticas. Cada obra cuenta una historia única."}
                    </p>
                </div>
            </header>
        </div>
    );
};

export default HeroSection;
